import React, { Component } from 'react';
import { Row, Col, Tabs } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import { TabsPosition } from 'antd/lib/tabs';
import CustomerTable from './CustomerTable';
import { States } from '../../components/public/StatesSelect';
import ContactTable from '../contact/ContactTable';
import RequirementTable from '../requirement/RequirementTable';
import { getCompanyUrlParam } from '../../utils';
const TabPane = Tabs.TabPane;

type TabsCustomState = {
    activeKey: string;
    panes: any;
    mode: TabsPosition;
};
class TabsCustom extends Component<any, TabsCustomState> {
    constructor(props: any) {
        super(props);
        const panes = [
            { title: '联系人列表', content: 'Content of Tab Pane 1', key: '1' },
            { title: '沟通记录', content: 'Content of Tab Pane 2', key: '2' },
            { title: '需求列表', content: 'Content of Tab Pane 3', key: '3' },
        ];
        this.state = {
            activeKey: panes[0].key,
            panes,
            mode: 'top',
        };
    }

    async componentDidMount() {
        const companyId = getCompanyUrlParam();
        await this.customerTableRef.getCustomerTableData(1, companyId, States.normal);
    }

    customerTableRef: CustomerTable;
    contactTableRef: ContactTable;
    requirementTableRef: RequirementTable
    newTabIndex: number = 0;

    callback = (key: string) => {
        if (key === "4") {
            window.location.href = `/#/app/customer/manager?company=${getCompanyUrlParam()}`;
        }
    };

    handleModeChange = (e: RadioChangeEvent) => {
        const mode = e.target.value;
        this.setState({ mode });
    };
    onChange = (activeKey: string) => {
        this.setState({ activeKey });
    };
    onEdit = (targetKey: string | React.MouseEvent<HTMLElement>, action: 'add' | 'remove'): any => {
        this[action](targetKey as string);
    };
    add = () => {
        const panes = this.state.panes;
        const activeKey = `newTab${this.newTabIndex++}`;
        panes.push({ title: 'New Tab', content: 'New Tab Pane', key: activeKey });
        this.setState({ panes, activeKey });
    };
    remove = (targetKey: string) => {
        let activeKey = this.state.activeKey;
        let lastIndex = 0;
        this.state.panes.forEach((pane: any, i: number) => {
            if (pane.key === targetKey) {
                lastIndex = i - 1;
            }
        });
        const panes = this.state.panes.filter((pane: any) => pane.key !== targetKey);
        if (lastIndex >= 0 && activeKey === targetKey) {
            activeKey = panes[lastIndex].key;
        }
        this.setState({ panes, activeKey });
    };

    render() {
        return (
            <div className="tabs-custom">
                <Row gutter={16}>
                    <Col className="gutter-row" md={25}>
                        <div className="gutter-box">
                        <Tabs
                            onChange={this.callback}
                            type="card"
                            tabBarExtraContent={
                                <button
                                    style={{
                                        padding: '5px 10px',
                                        backgroundColor: '#1890ff',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '14px'
                                    }}
                                    onClick={() => window.location.href = `/#/app/customer/manager?company=${getCompanyUrlParam()}`}
                                >
                                    新增联系人
                                </button>
                            }
                        >
                            <TabPane tab="联系人列表" key="1">         
                                <CustomerTable ref={(ref) => (this.customerTableRef = ref)} />
                            </TabPane>

                            <TabPane tab="沟通记录" key="2">
                                <ContactTable 
                                    ref={(ref) => (this.contactTableRef = ref)} 
                                    company={getCompanyUrlParam()}
                                    sales={null}
                                    way={null}
                                    customer={null}
                                    beginTime={null}
                                    endTime={null}
                                />
                            </TabPane>

                            <TabPane tab="需求列表" key="3">
                                <RequirementTable 
                                    ref={(ref) => (this.requirementTableRef = ref)} 
                                    companyId={getCompanyUrlParam()}
                                    salesId={null}
                                    states={null}
                                    beginTime={null}
                                    endTime={null}
                                    isMyRequirementPage={false}
                                />
                            </TabPane>
                        </Tabs>
                        </div>
                    </Col>
                    
                </Row>
            </div>
        );
    }
}

export default TabsCustom;
